const activateVideoEncodings = (logAnalyticsEvent = () => { }) =>
  /**
  * Activate/deactivate the encodings
  * @param {Object} peerConnection - the peer connection to apply the change
  * @param {boolean} active - True to activate, false to deactivate
  */
  async (peerConnection, active) => {
    if (!peerConnection) return;

    const videoSender = peerConnection.getSenders().find(({ track }) => track.kind === 'video');
    if (!videoSender) return;

    const parameters = videoSender.getParameters();
    parameters.encodings.forEach((encoding) => {
      // eslint-disable-next-line no-param-reassign
      encoding.active = active;
    });
    try {
      await videoSender.setParameters(parameters);
    } catch (error) {
      logAnalyticsEvent(`${active ? 'Activate' : 'Deactive'}EncodingsFailed`, 'Event',
        `${error.name}: ${error.message}`);
      // eslint-disable-next-line no-console
      console.error(`Error ${active ? 'activating' : 'deactivating'} video encodings.`);
    }
  };

export default {
  activateVideoEncodings,
};
